export enum TypePathLocation {
	Default = 0,
	Venio = 1,
	Empeo = 2,
}
